module.exports = __webpack_public_path__ + "img/phone-bg.182a6020.png";